/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { CustomHeader, Screen, Text } from "components"
import React, { useCallback, useEffect, useState } from "react"
import {
  ActivityIndicator,
  FlatList,
  Image,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { TabView } from "react-native-tab-view"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import { colors } from "colors"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { useStores } from "models"
import moment from "moment"
import useResponsiveWidth from "components/fitSize"

import coffeeImg from "../../../../assets/coffee_animation.gif"
import expiredImg from "../../../../assets/expired-img.png"
import claimedImg from "../../../../assets/claimed-img.png"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"

import RenderHtml from "react-native-render-html"
import { useColor } from "app/theme/getThemes"

export const ForYouScreen = () => {
  const navigation = useNavigation<any>()
  const { userStore } = useStores()

  useFocusEffect(
    useCallback(() => {
      getCoupon()
      getCouponHistory()
    }, []),
  )

  const getCoupon = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/voucher/coupon/${userStore?.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })

      if (res.ok) {
        const response = await res.json()

        setRewards(response)
      } else {
        const errorMsg = await res.json()
        console.log(errorMsg)
      }
    } catch (e) {
      flash("error", translate("errors.failedToUseVoucher"))
      console.error(e)
    }
  }

  const getCouponHistory = async () => {
    try {
      const res = await fetch(
        `${process.env.API_URL}/api/voucher_list/member/${userStore?.id}/coupon_used`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userStore?.accessToken}`,
          },
        },
      )

      if (res.ok) {
        const response = await res.json()
        setRewardHistory(response)
      } else {
        const errorMsg = await res.json()
        console.log(errorMsg)
        return []
      }
    } catch (e) {
      flash("error", translate("errors.failedToUseVoucher"))
      console.error(e)
      return []
    }
  }

  const { companyTheme } = useColor()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()
  const [reward, setRewards] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [rewardHistory, setRewardHistory] = useState([
    // {
    //   voucher_name: "Buy 5 get 1 free coffee",
    //   voucher_description: "",
    //   voucher_image: coffeeImg,
    //   totalRewards: 5,
    //   receivedReward: 3,
    // },
  ])

  const [index, setIndex] = useState(0)
  const [routes] = useState([
    { key: "first", title: "Ongoing Coupons" },
    { key: "second", title: "Expired Coupons" },
  ])

  const FirstRoute = () => <Content data={reward} type="ongoing" />

  const SecondRoute = () => <Content data={rewardHistory} type="history" />

  const Content = (props) => {
    const { data, type } = props
    const isHistory = type === "history"
    return (
      <FlatList
        contentContainerStyle={style.flatListContainer}
        data={data}
        showsVerticalScrollIndicator={false}
        ListEmptyComponent={() => {
          return (
            <View style={style.emptyContainer}>
              {isLoading ? (
                <ActivityIndicator size="large" color={companyTheme.first} />
              ) : (
                <>
                  <Image
                    source={require("../../../../assets/empty-icon.png")}
                    style={{ width: 100, height: 100, resizeMode: "contain" }}
                  />
                  <Text style={style.emptyTitle}>{translate("foryouScreen.noVoucher")}</Text>
                </>
              )}
            </View>
          )
        }}
        ListFooterComponent={() => {
          return (
            <>
              {/* {!isHistory && (
                <View style={{ alignItems: "center", marginTop: 20 }}>
                  <Text style={style.voucherDescription}>
                    {translate("foryouScreen.cannotFindVoucher")}
                  </Text>
                  <Text style={style.voucherDescription}>
                    {translate("foryouScreen.try")}{" "}
                    <Text
                      onPress={() => navigation.push("reward", { routeFrom: "history" })}
                      style={{ color: companyTheme.first }}
                    >
                      {translate("foryouScreen.searchHistory")}
                    </Text>
                  </Text>
                </View>
              )} */}
            </>
          )
        }}
        renderItem={({ item }) => {
          const regex = /<[^>]*>/gim
          const filteredDescriptionText = item?.voucher_description?.replace(regex, "")
          return (
            <View>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate("forYouDetails", {
                    item,
                    routeFrom: isHistory ? "history" : "coupon",
                  })
                }
                style={{
                  opacity: isHistory && 0.5,
                }}
              >
                <LinearGradient
                  style={[
                    style.tierContentContainer,
                    { paddingRight: 0, position: "relative", borderWidth: 0 },
                  ]}
                  colors={[companyTheme.first, companyTheme.second]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                >
                  <View
                    style={[
                      style.row,
                      {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-around",
                        paddingHorizontal: 20,
                        height: 100,
                      },
                    ]}
                  >
                    <View
                      style={{
                        width: "70%",
                        display: "flex",
                        justifyContent: "space-around",
                        height: "100%",
                      }}
                    >
                      <Text style={style.tierSpendText} numberOfLines={2}>
                        {item?.voucher_name}
                      </Text>
                      <View
                        style={{
                          width: "100%",
                          borderWidth: 1,
                          borderColor: "white",
                          borderStyle: "dashed",
                        }}
                      />
                      <Text style={style.tierSpendText} numberOfLines={2}>
                        {filteredDescriptionText}
                      </Text>
                    </View>

                    <View style={{ width: "20%" }}>
                      <Image
                        source={{
                          uri: item?.voucher_image,
                        }}
                        resizeMode="cover"
                        style={{ width: 70, height: 70, alignSelf: "flex-end", borderRadius: 15 }}
                      />
                    </View>
                  </View>
                  <View
                    style={{
                      position: "absolute",
                      width: 30,
                      height: 30,
                      borderRadius: 100,
                      backgroundColor: `white`,
                      top: 55,
                      left: -15,
                      zIndex: 1,
                    }}
                  />
                  <View
                    style={{
                      position: "absolute",
                      width: 30,
                      height: 30,
                      borderRadius: 100,
                      backgroundColor: `white`,
                      top: 55,
                      right: -15,
                      zIndex: 1,
                    }}
                  />
                </LinearGradient>
              </TouchableOpacity>
              {isHistory ? (
                <Image
                  source={claimedImg}
                  resizeMode="cover"
                  style={{
                    width: 100,
                    height: 100,
                    position: "absolute",
                    right: 15,
                    bottom: 20,
                    zIndex: 999,
                    opacity: 0.8,
                  }}
                />
              ) : null}
            </View>
          )
        }}
      />
    )
  }

  return (
    <>
      <CustomHeader
        headerTitle={translate("foryouScreen.title")}
        height={80}
        showBackButton
        withBalls
        longHeader
      />
      <Screen>
        <View style={style.container}>
          <TabView
            swipeEnabled={false}
            animationEnabled={false}
            lazy
            renderTabBar={(props) => (
              <LinearGradient
                style={[style.linearGradient, { height: 60 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <TouchableOpacity style={style.headerTabBarContainer}>
                  {props.navigationState.routes.map((route, i) => {
                    return (
                      <TouchableOpacity
                        key={i}
                        onPress={() => setIndex(i)}
                        style={[style.tabBar, index === i && style.selectedTabBar]}
                      >
                        <Text
                          style={
                            index === i
                              ? { color: companyTheme.first, fontWeight: "bold" }
                              : { color: colors.white }
                          }
                        >
                          {route.title}
                        </Text>
                      </TouchableOpacity>
                    )
                  })}
                </TouchableOpacity>
              </LinearGradient>
            )}
            navigationState={{ index, routes }}
            renderScene={({ route }) => {
              switch (route.key) {
                case "first":
                  return FirstRoute()
                default:
                  return SecondRoute()
              }
            }}
            onIndexChange={setIndex}
            initialLayout={{ width }}
          />
        </View>
      </Screen>
    </>
  )
}
